import axios from '../../config/axios';

export function getItems(params) {
    return axios().get(`sales-scheduling/items`, { params })
}

function search(query) {
    return axios().get(`sales-scheduling/items-search`, {
        params: {
            query
        }
    })
}

function measureUnits(itemId) {
    return axios().get(`sales-scheduling/items/${itemId}/measure-units`);
}

export default {
    get: getItems,
    search,
    measureUnits
}
